var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ButtonArrow"},React.createElement("path",{"id":"Vector 22 (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M14.9999 5.00008C15.3904 5.3906 15.3904 6.02376 14.9999 6.41429L7.99992 13.4143L0.999925 6.41429C0.609401 6.02376 0.609401 5.3906 0.999925 5.00008C1.39045 4.60955 2.02361 4.60955 2.41414 5.00007L7.99992 10.5859L13.5857 5.00008C13.9762 4.60955 14.6094 4.60955 14.9999 5.00008Z","fill":"#AAB8D9"})));
}

ArrowDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
